<template>
  <div class="content" v-if="cfg">
  <base-header class="pb-6">
  </base-header>
  <b-container fluid class="mt--6">
    <div>
      <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
        <template slot="header">
          <h3 class="mb-0">{{ this.model.id === undefined? crudConfig.form.newTitle : crudConfig.form.editTitle }}</h3>
          <p class="text-sm mb-0">
            Please fill out all required fields and submit
          </p>
        </template>
        <div>
          <card>
          <form @submit="submit">
            <template v-for="(field, idx) of fields">
            <!-- Input groups with icon -->
              <b-row>
                <b-col md="3">
                  <div v-if="field.type === undefined && field.array">
                    <div v-for="(item, index) in model[field.prop]" :key="index">
                      <span>
                      <base-input :label="field.label + ' (' + (index+1) + ')'"
                                  :required="field.required !== undefined? field.required : false"
                                  :type="field.format !== undefined? field.format : 'false'"
                                  v-model="model[field.prop][index]" />

                      <base-button @click.native="removeArrayItem(field.prop, index)"
                                   class="remove btn-link"
                                   type="danger"
                                   size="sm"
                                   icon>
                        Delete {{field.label}}
                      </base-button>
                        <p/>
                        </span>
                    </div>
                    <base-button @click.native="addArrayItem(field.prop)"
                                 class="edit btn-link"
                                 type="info"
                                 size="sm"
                                 icon>
                      Add {{field.label}}
                    </base-button>
                    <p/>
                  </div>

                  <base-input v-if="field.type === undefined && !field.array"
                              :label="field.label"
                              :name="field.prop"
                              :required="field.required !== undefined? field.required : false"
                              :type="field.format !== undefined? field.format : 'text'"
                              v-model="model[field.prop]"/>

                  <base-input v-if="field.type === 'select'" :label="field.label">
                    <el-select v-model="model[field.prop]" filterable>
                      <el-option v-for="option in field.listData"
                                 :key="option.value"
                                 :label="option.label"
                                 :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>

                  <base-input v-if="field.type === 'boolean'" :label="field.label">
                    <b-form-checkbox v-if="field.type === 'boolean'" class="mb-3" v-model="model[field.prop]" />
                  </base-input>

                </b-col>
              </b-row>
            </template>
            <base-button type="primary" native-type="submit">Submit</base-button>
          </form>
          </card>
        </div>
      </card>
    </div>
  </b-container>
  </div>
</template>

<script>
import crudConfig from "../../crud/crud-config";
import crudApi from "../../crud/crud-api";
import { Select, Option } from 'element-ui'
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'

export function backRoute() {
  window.history.back();
}

export default {
  props: ['entity', 'entityType'],
  components: {
    RouteBreadCrumb,
    [Select.name]: Select,
    [Option.name]: Option
  },
  created() {
    if (this.entity !== undefined) {
      this.model = this.entity
    }
  },
  data: _ => ({
    model: undefined,
    fields: [],
    crudConfig: {}
  }),
  computed: {
    cfg() {
      console.log("==========> form entity type : " + this.entityType)

      this.fields = crudConfig[this.entityType].form.formFields
      this.crudConfig = crudConfig[this.entityType]

      if (this.model === undefined) {
        console.log("model is undefined")

        if (crudConfig[this.entityType].model !== undefined) {
          this.model = JSON.parse(JSON.stringify(crudConfig[this.entityType].model));
        } else {
          this.model = JSON.parse(JSON.stringify(crudConfig.defaultModel));
        }
      }

      let cfg = crudConfig[this.entityType]
      return cfg
    }
  },
  methods: {
    submit(event) {
      event.preventDefault();

      if (this.model.id === undefined) {
        if (this.entityType === "organisations") {
          crudApi.createOrganisation(this.$store.state.auth.user.organisation_id, this.model).then(() => { this.$root.$refs.NavBar.reloadOrganisations() })
        } else {
          crudApi.post(this.$store.state.auth.user.organisation_id, this.entityType, this.model)
        }
      } else {
        crudApi.put(this.entityType, this.model)
      }

      backRoute()
    },
    arrayInputHandler(prop, index, e) {
      console.log('arrayInputHandler ' + e)

      this.model[prop][index] = e
    },
    addArrayItem(prop) {
      console.log("Adding array item for prop : " + prop)

      this.model[prop] = [...this.model[prop], '']
      // this.model[prop].push('');
    },
    removeArrayItem(prop, index) {
      this.model[prop].splice(index,1)
    },
  }
};
</script>
